import { render, staticRenderFns } from "./NkChartXl.vue?vue&type=template&id=b536b6ec&scoped=true"
import script from "./NkChartXl.vue?vue&type=script&lang=js"
export * from "./NkChartXl.vue?vue&type=script&lang=js"
import style0 from "./NkChartXl.vue?vue&type=style&index=0&id=b536b6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b536b6ec",
  null
  
)

export default component.exports